// src/hooks/useNavigationState.js

import react from 'react';
import { useLocation } from 'react-router-dom';
import debounce from 'lodash.debounce';

export const useNavigationState = (initialState, key) => {
  const location = useLocation();
  const [state, setState] = react.useState(() => {
    const storedState = sessionStorage.getItem(`${key}-${location.pathname}`);
    if (storedState) {
      try {
        return JSON.parse(storedState);
      } catch (e) {
        console.error('Error parsing stored state:', e);
      }
    }
    return initialState;
  });

  const debouncedSave = react.useMemo(() => debounce((value) => {
    sessionStorage.setItem(`${key}-${location.pathname}`, JSON.stringify(value));
  }, 300), [key, location.pathname]);

  react.useEffect(() => {
    debouncedSave(state);
    return () => debouncedSave.cancel();
  }, [state, debouncedSave]);

  return [state, setState];
};

export const useScrollRestoration = () => {
  const location = useLocation();
  react.useEffect(() => {
    const scrollPos = sessionStorage.getItem(`scrollPos-${location.pathname}`);
    if (scrollPos) {
      setTimeout(() => window.scrollTo(0, parseInt(scrollPos, 10)), 0);
    }
    const handleScroll = () => {
      sessionStorage.setItem(`scrollPos-${location.pathname}`, window.scrollY.toString());
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);
};
